<template>
  <div class="performance-comparison">
    <div class="perf-filler"></div>
    <h2 class="section-title">實績比較</h2>
    <div class="location-tabs">
      <button 
        v-for="location in locations" 
        :key="location" 
        :class="{ active: activeLocation === location }"
        @click="activeLocation = location"
      >
        {{ location }}
      </button>
    </div>
    <div class="comparison-container">
      <div class="before">
        <h3 class="before-after-mark">Before</h3>
        <img :src="image_dict[activeLocation].before" alt="Before Image" />
      </div>
      <div class="after">
        <h3 class="before-after-mark">After</h3>
        <img :src="image_dict[activeLocation].after" alt="After Image" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PerformanceComparison',
  data() {
    return {
      locations: ['敬業場', '草悟廣場', '台中土庫場', '桃園國軍總院場', '墾丁場'],
      activeLocation: '敬業場',
      image_dict: {
        '敬業場': {
          'before': require('@/assets/compare/敬業場施工前.jpg'),
          'after': require('@/assets/compare/敬業場施工後.jpg')
        },
        '草悟廣場': {
          'before': require('@/assets/compare/草悟廣場施工前.jpg'),
          'after': require('@/assets/compare/草悟廣場施工後.jpg')
        },
        '台中土庫場': {
          'before': require('@/assets/compare/台中土庫場施工前.jpg'),
          'after': require('@/assets/compare/台中土庫場施工後.jpg')
        },
        '桃園國軍總院場': {
          'before': require('@/assets/compare/桃園國軍總院施工前.jpg'),
          'after': require('@/assets/compare/桃園國軍總院施工後.jpg')
        },
        '墾丁場': {
          'before': require('@/assets/compare/kenting-before.jpg'),
          'after': require('@/assets/compare/kenting-after.jpg')
        }
      }
    }
  },
  mounted() {
    // Set the initial active location
    // this.activeLocation = this.locations[0];
    //preload all images
    for (const location in this.image_dict) {
      const beforeImage = new Image();
      beforeImage.src = this.image_dict[location].before;
      const afterImage = new Image();
      afterImage.src = this.image_dict[location].after;
    }
  }

}
</script>

<style scoped>
.performance-comparison {
  width: 1416px;
  margin: 0 auto;
  padding-bottom: 72px;
  background-color: white;
}

.perf-filler {
  height: 1px;
}

.section-title {
  margin-top: 72px;
  margin-bottom: 64px;
}

.location-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 58px;
  flex-wrap: wrap;
}

.location-tabs button {
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  padding: 6px 12px 6px 12px;
  border-radius: 8px;
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--green03);
}

.location-tabs button.active {
  background-color: var(--green03);
  color: white;
  font-weight: 700;
}

.comparison-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 24px;
  max-width: 1416px;
  margin: 0 auto;
}

.before,
.after {
  position:relative;
  background-color: var(--gray11);
  color: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: width 0.3s, height 0.3s;
  width: 696px;
  height: 432px;
  border-radius: 20px;
  font-family: Inter;
  font-size: 48px;
  font-weight: 700;
  line-height: 64.32px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  border-radius: 8px;
}

.after {
  background-color: var(--green01);
}

.before img,
.after img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.before-after-mark {
  position:absolute;

  top:32px;
  left:32px;

  margin: 0px;
  font-family: Inter;
  font-size: 48px;
  font-weight: 700;
  line-height: 64.32px;
  text-align: left;
}

/* Responsive Design */
@media (max-width: 560px) {
  .performance-comparison {
    width: 343px;
    padding-bottom: 32px;
  }

  .section-title {
    margin-top: 32px;
    margin-bottom: 30px;
  }

  .location-tabs {
    margin-bottom: 24px;
  }

  .location-tabs button {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  .location-tabs button.active {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
  }

  .comparison-container {
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }

  .before,
  .after {
    width: 343px;
    height: 212px;
  }

  

  .before-after-mark {
    top:16px;
    left:16px;
    font-size: 28px;
    font-weight: 700;
    line-height: 38.08px;
  }
}
</style>
